export default __webpack_public_path__ + "static/media/vishnu.c3404106.png";